import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

const FormularioProductos = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const esEdicion = !!id;

  const [producto, setProducto] = useState({
    id: "",
    id_categoria: "",
    categoria: "",
    id_subcategoria: "",
    subcategoria: "",
    nombre: "",
    imagen: "",
    cantidad: "",
    precio: "",
    precio_kg: "",
  });

  const [categorias, setCategorias] = useState([]);
  const [subcategorias, setSubcategorias] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    obtenerCategorias();
  }, []);

  useEffect(() => {
    if (esEdicion && categorias.length > 0) {
      obtenerProducto();
    }
  }, [categorias]);

  const obtenerCategorias = async () => {
    try {
      const res = await axios.get(`/api/productos/categorias`);
      setCategorias(res.data);
    } catch (e) {
      console.error("Error al obtener categorías:", e);
      setError("Error al cargar categorías");
    }
  };

  const obtenerProducto = async () => {
    try {
      const res = await axios.get(`/api/productos/${id}`);
      const data = res.data;

      const idCatNum = Number(data.id_categoria);
      const catSel = categorias.find(c => c.id_categoria === idCatNum);
      if (catSel) {
        setSubcategorias(catSel.subcategorias);
      } else {
        setSubcategorias([]);
      }

      let precio_kg_calc = "";
      const cantidadNum = parseFloat(data.cantidad);
      const precioNum = parseFloat(data.precio);
      if (!isNaN(cantidadNum) && cantidadNum > 0 && !isNaN(precioNum)) {
        precio_kg_calc = (precioNum / cantidadNum).toFixed(2);
      }

      setProducto({
        ...data,
        precio_kg: precio_kg_calc,
      });
    } catch (e) {
      console.error("Error al obtener producto:", e);
      setError("Error al cargar producto");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const actualizado = { ...producto, [name]: value };

    if (["precio", "cantidad"].includes(name)) {
      const cantidad = parseFloat(name === "cantidad" ? value : actualizado.cantidad);
      const precio = parseFloat(name === "precio" ? value : actualizado.precio);

      if (!isNaN(precio) && !isNaN(cantidad) && cantidad > 0) {
        actualizado.precio_kg = (precio / cantidad).toFixed(2);
      } else {
        actualizado.precio_kg = "";
      }
    }

    setProducto(actualizado);
  };

  const handleCategoriaChange = (e) => {
    const id_categoria = Number(e.target.value);
    const categoria = categorias.find(c => c.id_categoria === id_categoria);

    if (categoria) {
      setProducto(prev => ({
        ...prev,
        id_categoria,
        categoria: categoria.categoria,
        id_subcategoria: "",
        subcategoria: ""
      }));
      setSubcategorias(categoria.subcategorias);
    } else {
      setProducto(prev => ({
        ...prev,
        id_categoria: "",
        categoria: "",
        id_subcategoria: "",
        subcategoria: ""
      }));
      setSubcategorias([]);
    }
  };

  const handleSubcategoriaChange = (e) => {
    const id_subcategoria = Number(e.target.value);
    const subcat = subcategorias.find(s => s.id_subcategoria === id_subcategoria);

    if (subcat) {
      setProducto(prev => ({
        ...prev,
        id_subcategoria,
        subcategoria: subcat.subcategoria
      }));
    } else {
      setProducto(prev => ({
        ...prev,
        id_subcategoria: "",
        subcategoria: ""
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Confirmación antes de enviar
    const confirmacion = window.confirm(
      esEdicion ? "¿Estás seguro de actualizar el producto?" : "¿Estás seguro de crear el producto?"
    );
    if (!confirmacion) return;

    try {
      if (esEdicion) {
        await axios.put(`/api/productos/${id}`, producto);
        alert("✅ Producto editado correctamente");
      } else {
        await axios.post(`/api/productos`, producto);
        alert("✅ Producto añadido correctamente");
      }
      navigate(-1);
    } catch (e) {
      console.error("Error al guardar producto:", e);
      setError(e.response?.data?.error ? `Error al guardar producto: ${e.response.data.error}` : "Error al guardar producto");
    }
  };

  const handleCancelar = () => {
    navigate(-1);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>{esEdicion ? "Editar Producto" : "Crear Producto"}</h2>
      {error && <p style={styles.error}>{error}</p>}
      <form onSubmit={handleSubmit} style={styles.form}>

        <label style={styles.label}>
          ID:
          <input
            name="id"
            value={producto.id}
            onChange={handleChange}
            placeholder="ID"
            disabled={esEdicion}
            style={styles.input}
            required
          />
        </label>

        <label style={styles.label}>
          Nombre:
          <input
            name="nombre"
            value={producto.nombre}
            onChange={handleChange}
            placeholder="Nombre"
            style={styles.input}
            required
          />
        </label>

        <label style={styles.label}>
          URL Imagen:
          <input
            name="imagen"
            value={producto.imagen}
            onChange={handleChange}
            placeholder="URL Imagen"
            style={styles.input}
          />
        </label>

        <label style={styles.label}>
          Categoría:
          <select
            value={producto.id_categoria}
            onChange={handleCategoriaChange}
            style={styles.select}
            required
          >
            <option value="">-- Selecciona categoría --</option>
            {categorias.map(cat => (
              <option key={cat.id_categoria} value={cat.id_categoria}>
                {cat.categoria}
              </option>
            ))}
          </select>
        </label>

        <label style={styles.label}>
          Subcategoría:
          <select
            value={producto.id_subcategoria}
            onChange={handleSubcategoriaChange}
            style={styles.select}
            required
            disabled={!subcategorias.length}
          >
            <option value="">-- Selecciona subcategoría --</option>
            {subcategorias.map(sub => (
              <option key={sub.id_subcategoria} value={sub.id_subcategoria}>
                {sub.subcategoria}
              </option>
            ))}
          </select>
        </label>

        <label style={styles.label}>
          Cantidad (kg):
          <input
            name="cantidad"
            value={producto.cantidad}
            onChange={handleChange}
            placeholder="Cantidad"
            type="number"
            style={styles.input}
            min="0"
            step="any"
            required
          />
        </label>

        <label style={styles.label}>
          Precio (€):
          <input
            name="precio"
            value={producto.precio}
            onChange={handleChange}
            placeholder="Precio"
            type="number"
            style={styles.input}
            min="0"
            step="any"
            required
          />
        </label>

        <label style={styles.label}>
          Precio €/kg:
          <input
            name="precio_kg"
            value={producto.precio_kg}
            placeholder="€/kg"
            disabled
            style={{ ...styles.input, backgroundColor: "#f0f0f0" }}
          />
        </label>

        <div style={{ display: "flex", gap: "15px", marginTop: "10px" }}>
          <button type="button" onClick={handleCancelar} style={{ ...styles.button, backgroundColor: "#ccc", color: "#000", flex: 1 }}>
            {"Cancelar"}
          </button>
          <button type="submit" style={{ ...styles.button, flex: 1 }}>
            {esEdicion ? "Actualizar Producto" : "Crear Producto"}
          </button>
        </div>
      </form>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "600px",
    margin: "30px auto",
    padding: "20px 30px",
    backgroundColor: "#fff",
    borderRadius: "10px",
    boxShadow: "0 8px 15px rgba(0,0,0,0.1)",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  title: {
    textAlign: "center",
    marginBottom: "25px",
    color: "#333",
  },
  error: {
    color: "red",
    textAlign: "center",
    marginBottom: "15px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "18px",
  },
  label: {
    display: "flex",
    flexDirection: "column",
    fontWeight: "600",
    fontSize: "0.95rem",
    color: "#444",
  },
  input: {
    marginTop: "6px",
    padding: "10px 12px",
    borderRadius: "6px",
    border: "1.5px solid #ccc",
    fontSize: "1rem",
    outline: "none",
    transition: "border-color 0.3s ease",
  },
  select: {
    marginTop: "6px",
    padding: "10px 12px",
    borderRadius: "6px",
    border: "1.5px solid #ccc",
    fontSize: "1rem",
    outline: "none",
    cursor: "pointer",
    transition: "border-color 0.3s ease",
    backgroundColor: "#fff",
  },
  button: {
    marginTop: "10px",
    padding: "12px",
    fontSize: "1.1rem",
    fontWeight: "700",
    backgroundColor: "#007bff",
    border: "none",
    borderRadius: "8px",
    color: "white",
    cursor: "pointer",
    transition: "background-color 0.25s ease",
  },
};

export default FormularioProductos;
